import { createApp } from 'vue';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

import App from '@/App.vue';
import router from './router';
import store from './store';

applyPolyfills().then(() => {
  defineCustomElements(window);
});

createApp(App)
  .use(router)
  .use(store)
  .mount('#app');
